import React from "react";
import "../styles/Aboutus.css";

const AboutUs = () => {

  const message = "Need Cricket ID";
  const encodedMessage = encodeURIComponent(message);
  const ContactLink = `https://wa.me/919024000691?text=${encodedMessage}`;

  return (
    <section className="about-us-section" id="about-us">

      {/* Image */}
      <div className="about-us-image">
        <div className="image-card">
          <img src="About_ReddyAnna.webp" alt="About Reddy Anna" />
        </div>
      </div>

      {/* Content */}
      <div className="about-us-content">

        <h2>
          About <span className="highlight">Reddy Anna</span> Book
        </h2>

        <p>
          Welcome to a trusted legacy in fantasy cricket - a platform that has
          earned its reputation through reliability since 2010. Second only to
          the industry leader in size and reach, we pride ourselves on offering
          seamless transactions and a user-friendly experience.
        </p>

        <p>
          Experience innovation in online fantasy cricket with cutting-edge
          features designed for today's players. Enjoy instant account
          activation and round-the-clock withdrawal support that puts you in
          control.
        </p>

        {/* Buttons */}
        <div className="about-us-buttons">

          <a
            href={ContactLink}
            target="_blank"
            rel="noopener noreferrer"
            className="contact-btn"
          >
            Contact Us @ 6666896666
          </a>
          <br/>

          <a href="/about" className="more-about-link">
            More About Us <span className="tilted-arrow">➜</span>
          </a>

        </div>

      </div>

    </section>
  );
};

export default AboutUs;